import './App.css';
import AuthCluster from './AuthCluster';
import TokenData from './TokenData'
import TokenDataMyToken from './TokenData_myToken'
import TokenDataManga from './TokenData_manga'
import TokenDataRinra from './TokenData_rinra'

function App() {
  return (
    <div className="App">
      <AuthCluster />
      <h1>NFT marketplace from YT <small>(prototype <small>Ver 0.1</small>)</small></h1>
      <h2>Available NFT to buy</h2>
      <p>You are on FLOW testnetwork blockchain. As a prototype, the purchase cannot be completed.</p>
      {/* <TokenDataMyToken /> */}
      {/* <TokenData /> */}
      <TokenDataManga />
      <TokenDataRinra />
    </div>
  );
}
export default App;
